module.exports = __webpack_public_path__ + "media/club_product_v2/handicap_calculator-dcba4a18.webp";